import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

import HelpComponent from "../HelpComponent";
import moment from "moment/moment";
import axios from "axios";
import Cookies from "js-cookie";
import {ConfirmDialog} from "primereact/confirmdialog";

const _FM_GroupCustomersComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [loading, setLoading] = useState(false);

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                disabled={rowData.deleted_at_snapshot}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.location.href.includes('#/group')) {
                    navigate('/group/' + action + '/' + id + '?read=customer&customerId=' + rowData.id)
                  }
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                disabled={rowData.deleted_at_snapshot}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.location.href.includes('#/group')) {
                    navigate('/group/' + action + '/' + id + '?update=customer&customerId=' + rowData.id)
                  }
                }}/>
      </React.Fragment>
    );
  }

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-3 p-col-align-center"}>
          <h3 className={"p-my-0"}>
            {t('guest_list')}
          </h3>
        </div>
        {(action === 'update' || action === 'create') &&
          <div className={"p-col-12 p-lg-9 p-text-right p-col-align-center"}>
            <Button type="button" label={t('group_import')} icon={"pi pi-upload"}
                    disabled={props.isDistributed}
                    onClick={() => {
                      navigate('/group/' + action + '/' + props.groupId + '?import=group&groupId=' + props.groupId)
                    }}
                    className="p-button-warning p-ml-2"/>
            <Button type="button" label={t('group_distribute')} icon={"pi pi-paperclip"}
                    disabled={props.customers?.length === 0}
                    onClick={() => {
                      navigate('/group/' + action + '/' + props.groupId + '?distribute=auto&groupId=' + props.groupId)
                    }}
                    className="p-button-warning p-ml-2"/>
            <Button type="button" label={t('group_manual_distribute')} icon={"pi pi-paperclip"}
                    disabled={props.customers?.length === 0 || props.isDistributed}
                    onClick={() => {
                      const params = new URLSearchParams({
                        distribute: 'manual',
                        groupId: String(props.groupId),
                        accommodationId: String(props.accommodationId),
                        guestsCount: String(props.customers?.length ?? 0),
                      });
                      if (props.reservedFrom) {
                        params.set('reservedFrom', props.reservedFrom);
                      }
                      if (props.reservedTo) {
                        params.set('reservedTo', props.reservedTo);
                      }
                      navigate('/group/' + action + '/' + props.groupId + '?' + params.toString())
                    }}
                    className="p-button-warning p-ml-2"/>
          </div>
        }
      </div>
      <DataTable
        size={"small"}
        emptyMessage={t('empty_message')}
        value={props.customers}
        loading={loading}
        autoLayout={true}
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot) {
            if (window.location.href.includes('#/group')) {
              navigate('/group/' + action + '/' + id + '?update=customer&customerId=' + rowData.data.id)
            }
          }
        }}

      >
        <Column field="lastname" header={t('lastname')}/>
        <Column field="firstname" header={t('firstname')}/>
        <Column field="citizenship" header={t('citizenship')}/>
        <Column field="zip_code" header={t('zip_code')}/>
        <Column field="email" header={t('email')}/>
        <Column field="phone" header={t('phone')} className={"p-text-nowrap"}/>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_GroupCustomersComponent);
